import classNames from 'classnames';
import * as React from 'react';
import styles from './button-row.module.css';

interface ButtonRowProps {
    withMarginTop?: boolean;
    withMarginBottom?: boolean;
    style?: Record<string, string>;
    children: React.ReactNode;
    fullWidth?: boolean;
}

function ButtonRow({
    children,
    withMarginTop = false,
    withMarginBottom = false,
    style = {},
    fullWidth = false,
}: ButtonRowProps): React.ReactElement<ButtonRowProps> {
    return (
        <div
            style={{
                marginTop: withMarginTop ? '1rem' : '0',
                marginBottom: withMarginBottom ? '1rem' : '0',
                ...style,
            }}
            className={classNames(styles.ButtonRow, {
                [styles.Tight]: !fullWidth,
                [styles.FullWidth]: fullWidth,
            })}
        >
            {children}
        </div>
    );
}

export default ButtonRow;
